// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2H9z2","inputWrap":"CustomTip_inputWrap__3A-Jl"};